import { render, staticRenderFns } from "./workProposalExport.vue?vue&type=template&id=35515f9e&scoped=true"
import script from "./workProposalExport.vue?vue&type=script&lang=js"
export * from "./workProposalExport.vue?vue&type=script&lang=js"
import style0 from "./workProposalExport.vue?vue&type=style&index=0&id=35515f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35515f9e",
  null
  
)

export default component.exports